import { Controller } from "@hotwired/stimulus"

// Clears a toast after a few seconds, or straight away when its close button is
// clicked. Banners rendered with the page are left alone - those go away on the
// next navigation anyway.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.remove()
  }
}
